import {
  DEFAULT_CONVERSIONS_PERIOD_HOUR,
  MAX_CONVERSIONS_PERIOD_HOUR,
  MIN_CONVERSIONS_PERIOD_HOUR,
} from 'modules/campaigns/lib/constants';
import { CampaignState, CampaignType } from 'modules/domains/campaign';
import { ExperimentState, ExperimentType, MessageMedium } from 'modules/graphql';
import { WinningCriteriaTypeDefinition } from 'modules/graphql/types';
import { OriginalExperimentState } from '../types';

export const initialEditExperimentState: OriginalExperimentState = {
  id: 0,
  name: '',
  type: '' as ExperimentType,
  state: '' as ExperimentState,
  campaign: {
    id: 0,
    name: '',
    type: CampaignType.Blast,
    state: CampaignState.Draft,
    messageMedium: '' as MessageMedium,
    sendTimeUseRecipientTimeZones: false,
    conversions: [],
    lists: [],
  },
  variations: [],
  evenlySplitVariations: false,
  winningCriteria: {
    name: '',
    type: WinningCriteriaTypeDefinition.ConversionEvent,
  },
  attributionPeriodHours: 0,
  testSizePercentage: 0,
  holdout: null,
  testSendsPerVariation: 0,
  testDurationInMinutes: 0,
};

/** Holdout Group size */
export const DEFAULT_HOLDOUT_GROUP_SIZE = 20;
export const MIN_HOLDOUT_GROUP_SIZE = 0.01;
export const MAX_HOLDOUT_GROUP_SIZE = 99.99;

/** Attribution period hours */
export const DEFAULT_ATTRIBUTION_PERIOD_HOURS = DEFAULT_CONVERSIONS_PERIOD_HOUR;
export const MIN_ATTRIBUTION_PERIOD_HOURS = MIN_CONVERSIONS_PERIOD_HOUR;
export const MAX_ATTRIBUTION_PERIOD_HOURS = MAX_CONVERSIONS_PERIOD_HOUR;

/** Test group size (test with subset) */
export const DEFAULT_TEST_SIZE_PERCENTAGE = 20;
export const MIN_TEST_SIZE_PERCENTAGE = 0.01;
export const MAX_TEST_SIZE_PERCENTAGE = 99.99;

/** Test duration hours and minutes */
export const DEFAULT_TEST_DURATION_MINUTES = 0;
export const DEFAULT_TEST_DURATION_HOURS = 2;

/** Hours must be integer values between 0 and 168, inclusive */
export const MIN_TEST_DURATION_HOURS = 0;
export const MAX_TEST_DURATION_HOURS = 168;

/** Minutes must be integer values between 0 and 59, inclusive */
export const MIN_TEST_DURATION_MINUTES = 0;
export const MAX_TEST_DURATION_MINUTES = 59;

/** Error validations or behavior when minimum number of sends is non-integer or < 1 */
export const DEFAULT_MIN_SENDS_PER_VARIANT = 1000;
export const MIN_SENDS_PER_VARIANT = 1;
